import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage';
import SignInPage from './userFlow/signInPage';
import SignUpPage from './userFlow/signUpPage';
import CartPage from './shoppingFlow/cartPage';
import CheckoutPage from './shoppingFlow/checkoutPage';
import UserProfilePage from './userFlow/userProfilePage';
import OrderConfirmationPage from './shoppingFlow/OrderConfirmationPage';
import OrdersListPage from './shoppingFlow/OrdersListPage';
import AdminHomePage from './adminFlow/AdminHomePage';
import AdminProductsPage from './adminFlow/AdminProductsPage';
import AdminNewProductPage from './adminFlow/AdminNewProductPage';
import AdminEditProductPage from './adminFlow/AdminEditProductPage';
import AdminUsersPage from './adminFlow/AdminUsersPage';
import AdminOrdersPage from './adminFlow/AdminOrdersPage';
import AdminOrderDetailsPage from './adminFlow/AdminOrderDetailsPage';
import AboutUsPage from './userFlow/aboutUsPage';
import ContactPage from './userFlow/contactPage';
import ReturnsPage from './userFlow/returnsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/userprofile" element={<UserProfilePage />} />
        <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
        <Route path="/orders" element={<OrdersListPage />} />
        <Route path="/admin" element={<AdminHomePage />} />
        <Route path="/admin/products" element={<AdminProductsPage />} />
        <Route path="/admin/products/new" element={<AdminNewProductPage />} />
        <Route path="/admin/products/:id/edit" element={<AdminEditProductPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/orders" element={<AdminOrdersPage />} />
        <Route path="/admin/orders/:id" element={<AdminOrderDetailsPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/returns" element={<ReturnsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
